// @flow
import React from 'react';
import type {Node} from 'react';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Box, Popover, Dialog} from '@wellstone-solutions/web';
import Fade from '@mui/material/Fade';

type PropsType = {
  anchorEl: HTMLElement | null,
  children: Node,
  onClose: () => void,
  onTransitionExited?: () => void,
};

export const ResponsiveDialog = ({
  anchorEl,
  children,
  onClose,
  onTransitionExited,
}: PropsType): Node => {
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return isMobile ? (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      onTransitionExited={onTransitionExited}>
      <Box p={2}>{children}</Box>
    </Dialog>
  ) : (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      TransitionComponent={Fade}
      onTransitionExited={onTransitionExited}
      sx={{
        '& .MuiPopover-paper': {
          borderRadius: '20px',
          width: '500px',
        },
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 16,
        horizontal: 16,
      }}>
      <Box p={2}>{children}</Box>
    </Popover>
  );
};
